import { useContext, useEffect } from "preact/hooks";
import SnackbarContext from "@/context/SnackbarContext";

function useSnackBar() {
	const { snackBarOpen, setSnackBarOpen } = useContext(SnackbarContext);
	const { snackBarMessage, setSnackBarMessage } = useContext(SnackbarContext);
	const { timeoutId, setTimeoutId } = useContext(SnackbarContext);
	const { showMeButton, setShowMeButton } = useContext(SnackbarContext);

	function handleOpen(message, showMeButton = false) {
		setSnackBarMessage(message);
		setSnackBarOpen(true);
		setShowMeButton(showMeButton);

		if (timeoutId) {
			clearTimeout(timeoutId);
		}

		const id = setTimeout(() => {
			setSnackBarOpen(false);
		}, 4000);

		setTimeoutId(id);
	}

	useEffect(() => {
		return () => {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
		};
	}, [timeoutId]);

	return {
		snackBarOpen,
		setSnackBarOpen,
		snackBarMessage,
		handleOpen,
		showMeButton
	};
}
export default useSnackBar;
